import React from "react";
import { Button } from "primereact/button";
import { useState, useEffect, useCallback } from "react";
import "../Feedbacks/Feedback.scss";
import "../Registration/KBARegistration.scss";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import "primereact/resources/themes/lara-light-blue/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import { Checkbox } from "primereact/checkbox";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { InputText } from "primereact/inputtext";
import axios from "axios";
import { SplitButton } from "primereact/splitbutton";
import { PiTable } from "react-icons/pi";
import DeletePopup from "../Components/DeletePopup";
import ShowRegisteredData from "./ShowRegisteredData";
import {
  deleteRegistrationurl,
  getMembershipurl,
} from "../../Services/BackendUrl";
import * as XLSX from "xlsx";
import pdfMake from "pdfmake/build/pdfmake";
import * as pdfFonts from "pdfmake/build/vfs_fonts";
import { encryptedAuth } from "../../Services/EncryptData";
pdfMake.vfs = pdfFonts?.pdfMake?.vfs;

const KBARegistration = ({
  setActivePage,
  showKbaDataTable,
  setShowKbaDataTable,
  setIsExporting,
  showSearch,
  isShowSearch,
  isShowEditIcon,
  setIsShowEditIcon,
}) => {
  const [searchText, setSearchText] = useState("");
  const [customers, setCustomers] = useState([]);
  const [filteredCustomers, setFilteredCustomers] = useState(customers);
  const [selectedRows, setSelectedRows] = useState([]);
  const [showCheckboxes, setShowCheckboxes] = useState(false);
  const [registerdCustomers, setRegisteredCustomers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showDeletePopup, setShowDeletePopup] = useState(false);
  const [selectedLocalid, setSelectedLocalid] = useState(null);
  const [isMultipleDelete, setIsMultipleDelete] = useState(false);
  const [showDetails, setShowDetails] = useState(false);
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [isEditMode, setIsEditMode] = useState(false);

  const exportPDF = async () => {
    const docDefinition = {
      pageSize: "A4",
      pageMargins: [20, 20, 20, 20],
      content: customers.map((customer, index) => ({
        stack: [
          { text: `Customer ${index + 1}`, style: "header" },

          {
            text: "Personal Information",
            style: "subheader",
            margin: [0, 10, 0, 0],
          },

          {
            columns: [
              {
                width: "50%",
                stack: [
                  { text: "Name:", bold: true, margin: [0, 5, 0, 0] },
                  { text: customer.fullName || "", fontSize: 11 },
                  {
                    text: "Whatsapp Number:",
                    bold: true,
                    margin: [0, 5, 0, 0],
                  },
                  { text: customer.whatsAppNumber || "", fontSize: 11 },
                  { text: "Gender:", bold: true, margin: [0, 5, 0, 0] },
                  { text: customer.gender || "", fontSize: 11 },
                  {
                    text: "Address (Street):",
                    bold: true,
                    margin: [0, 5, 0, 0],
                  },
                  { text: customer.address2 || "", fontSize: 11 },
                  { text: "Country:", bold: true, margin: [0, 5, 0, 0] },
                  { text: customer.country || "", fontSize: 11 },
                  {
                    text: "Civil ID Number:",
                    bold: true,
                    margin: [0, 5, 0, 0],
                  },
                  { text: customer.civilIdNumber || "", fontSize: 11 },
                  { text: "Photo Proof:", bold: true, margin: [0, 5, 0, 0] },
                  { text: customer.photoProof || "", fontSize: 11 },
                ],
                margin: [0, 10, 10, 0],
              },
              {
                width: "50%",
                stack: [
                  { text: "Email Address:", bold: true, margin: [0, 5, 0, 0] },
                  { text: customer.emailAddress || "", fontSize: 11 },
                  { text: "Date of Birth:", bold: true, margin: [0, 5, 0, 0] },
                  { text: formatDate(customer.dateOfBirth), fontSize: 11 },
                  {
                    text: "Address (Building Adress):",
                    bold: true,
                    margin: [0, 5, 0, 0],
                  },
                  { text: customer.address || "", fontSize: 11 },

                  { text: "State/Province:", bold: true, margin: [0, 5, 0, 0] },
                  { text: customer.state || "", fontSize: 11 },
                  { text: "Zip Code:", bold: true, margin: [0, 5, 0, 0] },
                  { text: customer.zipcode || "", fontSize: 11 },
                  { text: "Civil ID Image:", bold: true, margin: [0, 5, 0, 0] },
                  { text: customer.civilIdImage || "", fontSize: 11 },
                ],
                margin: [0, 10, 10, 0],
              },
            ],
          },

          {
            text: "Emergency Contact Information",
            style: "subheader",
            margin: [0, 10, 0, 0],
          },
          {
            columns: [
              {
                width: "33%",
                stack: [
                  { text: "First Name:", bold: true, margin: [0, 10, 0, 0] },
                  {
                    text: customer.emergencyContactFirstName || "",
                    fontSize: 11,
                  },
                ],
              },
              {
                width: "33%",
                stack: [
                  { text: "Last Name:", bold: true, margin: [0, 10, 0, 0] },
                  {
                    text: customer.emergencyContactLastName || "",
                    fontSize: 11,
                  },
                ],
              },
              {
                width: "33%",
                stack: [
                  { text: "Phone:", bold: true, margin: [0, 10, 0, 0] },
                  {
                    text: customer.emergencyContactPhoneNumber || "",
                    fontSize: 11,
                  },
                ],
              },
            ],
          },
          {
            text: "Relationship:",
            bold: true,
            margin: [0, 5, 0, 0],
          },
          { text: customer.emergencyContactRelationship || "", fontSize: 11 },

          {
            text: "Medical Information",
            style: "subheader",
            margin: [0, 10, 0, 0],
          },
          {
            columns: [
              {
                width: "50%",
                stack: [
                  {
                    text: "Do you have any medical conditions?",
                    bold: true,
                    margin: [0, 10, 0, 0],
                  },
                  { text: customer.medicalCondition || "", fontSize: 11 },
                ],
              },
              {
                width: "50%",
                stack: [
                  { text: "Blood Group:", bold: true, margin: [0, 10, 0, 0] },
                  { text: customer.bloodGroup || "", fontSize: 11 },
                ],
              },
            ],
          },
          {
            text: customer.medicalConditionDetails && "Condition Details:",
            bold: true,
            margin: [0, 5, 0, 0],
          },
          { text: customer.medicalConditionDetails || "", fontSize: 11 },

          {
            text: "",
            pageBreak: index !== customers.length - 1 ? "after" : "",
          },
        ],
      })),
      styles: {
        header: {
          fontSize: 16,
          bold: true,
          marginBottom: 8,
          color: "#0e92d8",
        },
        subheader: {
          fontSize: 14,
          bold: true,
          color: "#0e92d8",
        },
      },
    };

    pdfMake.createPdf(docDefinition).download("Customers.pdf");
  };

  const formatDate = (date) => {
    if (!date) return "";
    const d = new Date(date);
    const day = String(d.getDate()).padStart(2, "0");
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const year = d.getFullYear();
    return `${day}-${month}-${year}`;
  };

  const exportCSV = () => {
    const exportData = customers.map((customer, index) => ({
      "S.No": index + 1,
      FullName: customer.fullName,
      Email: customer.emailAddress,
      Phone: customer.phoneNumber,
      WhatsApp: customer.whatsAppNumber,
      DateOfBirth: formatDate(customer.dateOfBirth),
      Gender: customer.gender,
      Address1: customer.address,
      Address2: customer.address2,
      City: customer.city,
      State: customer.state,
      Zipcode: customer.zipcode,
      Country: customer.country,
      CivilIDNumber: customer.civilIdNumber,
      IDExpiryDate: formatDate(customer.idExpireDate),
      PhotoProofURL: customer.photoProof,
      CivilIdIamge: customer.civilIdImage,
      EmergencyContactFirstName: customer.emergencyContactFirstName,
      EmergencyContactLastName: customer.emergencyContactLastName,
      EmergencyContactPhone: customer.emergencyContactPhoneNumber,
      EmergencyContactRelation: customer.emergencyContactRelationship,
      MedicalCondition: customer.medicalCondition,
      MedicalConditionDetails: customer.medicalConditionDetails,
      BloodGroup: customer.bloodGroup,
      MembershipType: customer.membershipType,
      PreferredStartDate: formatDate(customer.preferredStartDate),
      SubmittedOn: formatDate(customer.submittedOn),
      UpdatedOn: formatDate(customer.updatedOn),
    }));

    const worksheet = XLSX.utils.json_to_sheet(exportData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Customers");

    const range = XLSX.utils.decode_range(worksheet["!ref"]);
    for (let R = range.s.r + 1; R <= range.e.r; ++R) {
      const cellAddress = XLSX.utils.encode_cell({ r: R, c: 0 });
      if (!worksheet[cellAddress]) continue;
      if (!worksheet[cellAddress].s) worksheet[cellAddress].s = {};
      worksheet[cellAddress].s.alignment = { horizontal: "center" };
    }

    worksheet["!cols"] = [
      { wch: 6 },
      ...new Array(Object.keys(exportData[0]).length - 1).fill({ wch: 20 }),
    ];

    XLSX.writeFile(workbook, "Customers.xlsx");
  };

  const showCustomerData = (localid) => {
    const customerToShow = customers.find((c) => c.localid === localid);
    setSelectedCustomer(customerToShow);

    setIsEditMode(false);
    setShowDetails(true);
    setActivePage("registration");
    setShowKbaDataTable(false);
    isShowSearch(false);
  };

  const editData = (localid) => {
    const customerToEdit = customers.find((c) => c.localid === localid); 
    setSelectedCustomer(customerToEdit);
    setIsEditMode(true);
    setShowDetails(true);
    setShowKbaDataTable(false);
    isShowSearch(false);
    setIsShowEditIcon(false);
  };

  const deleteRegisteredData = (LocalId) => {
    setShowDeletePopup(true);
    setSelectedLocalid(LocalId);
    setIsMultipleDelete(false);
  };

  const deleteMultipleData = () => {
    setIsMultipleDelete(true);
    setShowDeletePopup(true);
  };

  const confirmDelete = async () => {
    const customer = customers.find((c) => c.localid === selectedLocalid);
    if (!customer) {
      console.error("Customer not found for local ID:", selectedLocalid);
      return;
    }
    const serverId = [];
    serverId.push(customer.userId);
    try {
      const response = await axios.post(
        deleteRegistrationurl,
        { userIds: serverId },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization : `Encrypted ${encryptedAuth}`
          },
        }
      );
      if (response.data.message) {
        alert("Data Deleted");

        const remainingCustomers = customers.filter(
          (customer) => !serverId.includes(String(customer.userId))
        );

        const reindexed = remainingCustomers.map((c, i) => ({
          ...c,
          localid: (i + 1).toString().padStart(2, "0"),
          checkbox: false,
        }));

        setCustomers(reindexed);
      }
    } catch (error) {
      console.error("Error deleting user:", error.response?.data || error.message);
    } finally {
      setShowDeletePopup(false);
    }
  };

  const confirmMultipleDelete = async () => {
    if (showCheckboxes) {
      const selectedServerIds = customers
        .filter((c) => selectedRows.includes(c.localid))
        .map((c) => c.userId);

      if (selectedServerIds.length === 0) {
        alert("No items selected for deletion.");
        return;
      }

      try {
        const response = await axios.post(
          deleteRegistrationurl,
          { userIds: selectedServerIds },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization : `Encrypted ${encryptedAuth}`
            },
          }
        );

        if (response.data.message) {
          alert("Selected Datas Deleted");
          const remainingCustomers = customers.filter(
            (customer) => !selectedServerIds.includes(String(customer.userId))
          );

          const reindexed = remainingCustomers.map((c, i) => ({
            ...c,
            localid: (i + 1).toString().padStart(2, "0"),
            checkbox: false,
          }));

          setCustomers(reindexed);
          setSelectedRows([]);
          setShowCheckboxes(false);
        }
      } catch (error) {
        console.error("Error deleting users:", error.response?.data || error.message);
        alert("Failed to delete selected feedbacks.");
      } finally {
        setShowDeletePopup(false);
      }
    } else {
      const updated = customers.map((c) => ({ ...c, checkbox: true }));
      setCustomers(updated);
      setShowCheckboxes(true);
    }
  };

  const actionBodyTemplate = (rowData) => {
    return (
      <div className="action-column">
        <Button
          icon="pi pi-eye"
          onClick={() => showCustomerData(rowData.localid)}
        />
        <Button
          icon="pi pi-trash"
          onClick={() => deleteRegisteredData(rowData.localid)}
        />
        <Button
          icon="pi pi-file-edit"
          onClick={() => editData(rowData.localid)}
        />
      </div>
    );
  };

  const checkboxBodyTemplate = (rowData) => {
    if (!rowData.checkbox) return null;

    return (
      <Checkbox
        checked={selectedRows.includes(rowData.localid)}
        onChange={(e) => {
          const isChecked = e.checked;

          setSelectedRows((prevSelected) => {
            const newSelected = isChecked
              ? [...prevSelected, rowData.localid]
              : prevSelected.filter((localid) => localid !== rowData.localid);

            const updatedCustomers = customers.map((c) =>
              c.localid === rowData.localid ? { ...c, isChecked: isChecked } : c
            );
            setCustomers(updatedCustomers);

            const updatedFiltered = filteredCustomers.map((c) =>
              c.localid === rowData.localid ? { ...c, isChecked: isChecked } : c
            );
            setFilteredCustomers(updatedFiltered);

            return newSelected;
          });
        }}
      />
    );
  };

  const customerFields = [
    { field: "localid", header: "S.No" },
    { field: "fullName", header: "Name" },
     {field:"userId",header:"Registration ID"},
    { field: "membershipType", header: "Membership" },
    { field: "phoneNumber", header: "Contact Number" },
    { field: "submittedOn", header: "Applied On" },
    { field: "actions", header: "Actions", body: actionBodyTemplate },
   
  ];

  const fetchRegisteredcustomers = useCallback(async () => {
    try {
      const response = await axios.get(getMembershipurl, {
        headers: {
          Authorization : `Encrypted ${encryptedAuth}`
        },
      });
      setRegisteredCustomers(response.data.users);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching users:", error);
      setLoading(false);
    } finally {
      setIsExporting(false);
    }
  }, [setIsExporting]);

  useEffect(() => {
    fetchRegisteredcustomers();
  }, [fetchRegisteredcustomers]);

  useEffect(() => {
    if (registerdCustomers.length > 0) {
      const formatted = registerdCustomers.map((customer, index) => ({
        ...customer,
        fullName: `${customer.firstName || ""} ${
          customer.lastName || ""
        }`.trim(),
        localid: (index + 1).toString().padStart(2, "0"),
      }));
      setCustomers(formatted);
    }
  }, [registerdCustomers]);

  const items = [
    {
      label: "PDF",
      icon: "pi pi-file-pdf",
      command: () => {
        exportPDF();
      },
    },
    {
      label: "CSV",
      icon: "pi pi-file-excel",
      command: () => {
        exportCSV();
      },
    },
  ];

  const handleSearch = (e) => {
    const value = e.target.value.toLowerCase();
    setSearchText(value);
  };

  const filteredData =
    searchText.trim() === ""
      ? customers
      : customers.filter((customer) => {
          const nameMatch = customer.fullName
            ?.toLowerCase()
            .includes(searchText);
          const membershipTypeMatch = customer.membershipType
            ?.toLowerCase()
            .includes(searchText);
          const submittedMatch = customer.submittedOn
            ?.toLowerCase()
            .includes(searchText);
          return nameMatch || membershipTypeMatch || submittedMatch;
        });

  return (
    <>
      <div className="admin-feedback-container">
        <div className="fb-nav-container">
          <div className="fb-icon-title">
            <div className="fb-icon-box">
              <PiTable className="fb-icon" />
            </div>
            <div className="fb-title-box">KBA Registration</div>
          </div>
          <div className="fb-navoptions-container">
            {showSearch && (
              <div className="searchbox-container">
                <IconField iconPosition="left">
                  <InputIcon className="pi pi-search" />
                  <InputText
                    placeholder="Search here"
                    value={searchText}
                    onChange={handleSearch}
                  />
                </IconField>
              </div>
            )}
          </div>
          {showSearch && (
            <div className="kba-navoptions-container">
              <div className="kba-exportas-box">
                <SplitButton
                  label="Export As"
                  icon="pi pi-cloud-download"
                  className="custom-split-btn"
                  model={items}
                  dropdownIcon="pi pi-chevron-down"
                  appendTo="self"
                />
              </div>
            </div>
          )}
        </div>

        {showDetails && showKbaDataTable === false ? (
          <ShowRegisteredData
            customer={selectedCustomer}
            isShowEditMode={isEditMode}
            setIsShowEditMode={setIsEditMode}
            setShowDetails={setShowDetails}
            showKbaDataTable={showKbaDataTable}
            setShowKbaDataTable={setShowKbaDataTable}
            getMembershipurl={getMembershipurl}
            setRegisteredCustomers={setRegisteredCustomers}
            setIsExporting={setIsExporting}
            isShowSearch={isShowSearch}
            isShowEditIcon={isShowEditIcon}
            setIsShowEditIcon={setIsShowEditIcon}
          />
        ) : (
          <div className="fb-table-container kba-datatable">
            <DataTable
              value={filteredData}
              scrollable
              style={{ width: "100%" }}
              className="fb-datatable"
              loading={loading}
              paginator
              rows={5}
               emptyMessage="No available options" 
              paginatorTemplate={{
                layout: "PrevPageLink PageLinks NextPageLink",
                FirstPageLink: (options) => {
                  return (
                    <button
                      type="button"
                      className="p-paginator-first p-paginator-element p-link"
                      onClick={options.onClick}
                      disabled={options.disabled}
                    >
                      <i
                        className="pi pi-angle-double-left"
                        style={{ marginRight: "5px" }}
                      ></i>
                      First
                    </button>
                  );
                },
                PrevPageLink: (options) => {
                  return (
                    <button
                      type="button"
                      className="p-paginator-prev p-paginator-element p-link"
                      onClick={options.onClick}
                      disabled={options.disabled}
                    >
                      <i
                        className="pi pi-angle-left"
                        style={{ marginRight: "5px" }}
                      ></i>
                      Back
                    </button>
                  );
                },
                LastPageLink: (options) => {
                  return (
                    <button
                      type="button"
                      className="p-paginator-last p-paginator-element p-link"
                      onClick={options.onClick}
                      disabled={options.disabled}
                    >
                      <i
                        className="pi pi-angle-double-right"
                        style={{ marginRight: "5px" }}
                      ></i>
                      Last
                    </button>
                  );
                },
                NextPageLink: (options) => {
                  return (
                    <button
                      type="button"
                      className="p-paginator-next p-paginator-element p-link"
                      onClick={options.onClick}
                      disabled={options.disabled}
                    >
                      Next
                      <i
                        className="pi pi-angle-right"
                        style={{ marginRight: "5px" }}
                      ></i>
                    </button>
                  );
                },
              }}
            >
              {customerFields.map((col, index) => (
                <Column
                  key={index}
                  field={col.field !== "actions" ? col.field : undefined}
                  header={col.header}
                  body={
                    col.field === "localid"
                      ? (rowData, options) => (
                          <span>
                            {(options.rowIndex + 1).toString().padStart(2, "0")}
                          </span>
                        )
                      : col.field === "submittedOn"
                      ? (rowData) => {
                          const date = new Date(rowData.submittedOn);
                          const formatted = date
                            .toLocaleDateString("en-GB")
                            .replace(/\//g, "-"); 
                          return <span>{formatted}</span>;
                        }
                      : col.body
                  }
                  headerStyle={
                    col.field === "localid"
                      ? {
                          backgroundColor: "transparent",
                          color: "#fff",
                          border: "#7FC5FF26",
                          borderTopLeftRadius: "25px",
                          borderBottomLeftRadius: "25px",
                          padding: "25px 10px 25px 10px",
                          textAlign: "center",
                        }
                      : {
                          backgroundColor: "transparent",
                          color: "#fff",
                          border: "#7FC5FF26",
                        }
                  }
                />
              ))}

              <Column
                header={
                  <Button
                    style={{ backgroundColor: "transparent", border: "none" }}
                    icon={
                      <i
                        className={`pi ${
                          showCheckboxes ? "pi-trash" : "pi-pencil"
                        }`}
                        style={{
                          color: showCheckboxes ? "#FF4649" : "inherit",
                        }}
                      />
                    }
                    onClick={() => {
                      if (showCheckboxes) {
                        const anyChecked = customers.some((c) => c.isChecked);

                        if (anyChecked) {
                          deleteMultipleData(); 
                        } else {
                          setShowCheckboxes(false);

                          const updated = customers.map((c) => ({
                            ...c,
                            checkbox: false,
                            isChecked: false,
                          }));

                          setCustomers(updated);
                          setSelectedRows([]); 
                        }
                      } else {
                        const updated = customers.map((c) => ({
                          ...c,
                          checkbox: true,
                        }));
                        setCustomers(updated);
                        setShowCheckboxes(true);
                      }
                    }}
                    severity={showCheckboxes ? "danger" : "info"}
                  />
                }
                body={checkboxBodyTemplate}
                headerStyle={{
                  backgroundColor: "transparent",
                  color: "#fff",
                  border: "#7FC5FF26",
                  borderTopRightRadius: "25px",
                  borderBottomRightRadius: "25px",
                }}
              />
            </DataTable>
          </div>
        )}
        <DeletePopup
          visible={showDeletePopup}
          onHide={() => {
            setShowDeletePopup(false);
            setShowCheckboxes(false);
            const updated = customers.map((c) => ({
              ...c,
              checkbox: false,
              isChecked: false,
            }));
            setCustomers(updated);
            const updatedFiltered = filteredCustomers.map((c) => ({
              ...c,
              checkbox: false,
              isChecked: false,
            }));
            setFilteredCustomers(updatedFiltered);
            setSelectedRows([]);
          }}
          onConfirm={isMultipleDelete ? confirmMultipleDelete : confirmDelete}
        />

        <div id="print-area" style={{ display: "none" }}>
          {customers.map((customer, index) => (
            <div
              key={customer.localid || index}
              className="pdf-customer-page"
              style={{
                pageBreakAfter: "always",
                padding: "20px",
                width: "210mm",
                height: "297mm",
              }}
            >
              <h2 style={{ color: "#0e92d8" }}>Customer {index + 1}</h2>

              <h3 style={{ color: "#0e92d8" }}>Personal Information</h3>
              <p>
                <strong>Name:</strong> {customer.fullName}
              </p>
              <p>
                <strong>Whatsapp Number:</strong> {customer.whatsAppNumber}
              </p>
              <p>
                <strong>Gender:</strong> {customer.gender}
              </p>
              <p>
                <strong>Street Address:</strong> {customer.address2}
              </p>
              <p>
                <strong>Country:</strong> {customer.country}
              </p>
              <p>
                <strong>Civil ID Number:</strong> {customer.civilIdNumber}
              </p>
              <p>
                <strong>Photo Proof:</strong> {customer.photoProof}
              </p>
              <p>
                <strong>Email Address:</strong> {customer.emailAddress}
              </p>
              <p>
                <strong>Date of Birth:</strong>{" "}
                {formatDate(customer.dateOfBirth)}
              </p>
              <p>
                <strong>Building Address:</strong> {customer.address}
              </p>
              <p>
                <strong>State:</strong> {customer.state}
              </p>
              <p>
                <strong>Zip Code:</strong> {customer.zipcode}
              </p>
              <p>
                <strong>Civil ID Image:</strong> {customer.civilIdImage}
              </p>

              <h3 style={{ color: "#0e92d8" }}>Emergency Contact</h3>
              <p>
                <strong>First Name:</strong>{" "}
                {customer.emergencyContactFirstName}
              </p>
              <p>
                <strong>Last Name:</strong> {customer.emergencyContactLastName}
              </p>
              <p>
                <strong>Phone:</strong> {customer.emergencyContactPhoneNumber}
              </p>
              <p>
                <strong>Relationship:</strong>{" "}
                {customer.emergencyContactRelationship}
              </p>

              <h3 style={{ color: "#0e92d8" }}>Medical Information</h3>
              <p>
                <strong>Condition:</strong> {customer.medicalCondition}
              </p>
              <p>
                <strong>Blood Group:</strong> {customer.bloodGroup}
              </p>
              <p>
                <strong>Condition Details:</strong>{" "}
                {customer.medicalConditionDetails}
              </p>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default KBARegistration;
